import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MONTHLY_ORDER_LIMIT } from '@models';

@Component({
  selector: 'lib-counter',
  templateUrl: './counter.component.html',
  styleUrl: './counter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon],
})
export class CounterComponent {
  productName = input.required<string>();
  reduceLabel = computed(() => `Reducing ${this.productName()}`);
  increaseLabel = computed(() => `Increasing ${this.productName()}`);
  count = input(1);
  min = input(1);
  max = input(MONTHLY_ORDER_LIMIT);
  modifiedCount = signal(this.count());
  disabled = input<boolean>(false);

  disabledDecrement = computed(() => this.disabled() || this.modifiedCount() <= this.min());
  disabledIncrement = computed(() => this.disabled() || this.modifiedCount() >= this.max());

  hideButtons = input<boolean>(false);
  change = output<number>();

  constructor() {
    effect(() => {
      this.modifiedCount.set(this.count());
    });
  }

  decrement(): void {
    if (this.disabledDecrement()) return;
    this.modifiedCount.update((v) => Math.max(this.min(), v - 1));
    this.emitChange();
  }

  increment() {
    if (this.disabledIncrement()) return;
    this.modifiedCount.update((v) => Math.min(this.max(), v + 1));
    this.emitChange();
  }

  private emitChange(): void {
    this.change.emit(this.modifiedCount());
  }
}
